import React, { useEffect } from 'react';
import { useAnalyticsContext } from '../../../config/GoogleTagManagerEvents';
import { VARIABLE_CONFIG } from '../../../constants/analyticsConstants/Variables';
import { logError } from '../../global/utils/logger';
import SearchResultItemCard from '../components/SearchResultItemCard';

export default function RelatedInfo(props) {
    const { relatedState } = props;
    const { sendEventsForClick } = useAnalyticsContext();
    const analyticsEvent = () => {
        try {
            sendEventsForClick(
                VARIABLE_CONFIG.EVENT.UAEVENT,
                VARIABLE_CONFIG.ECOMMERCE.UNDEFINED,
                VARIABLE_CONFIG.EVENT_CATEGORY.SEARCH,
                VARIABLE_CONFIG.EVENT_ACTION.SEARCH_RELATED_INFO,
                `${VARIABLE_CONFIG.EVENT_ACTION.RELATED_INFO} (${(relatedState?.results).length})`
            );
        } catch (error) {
            logError(error, false, 'analyticsEvent');
        }
    };
    useEffect(() => {
        analyticsEvent();
    }, []);
    const getMediaType = (imageUrl, contentType) => {
        if (imageUrl) {
            return 'image';
        } else if (String(contentType).toLowerCase() === 'videos') {
            return 'video';
        } else return '';
    };
    return (
        <>
            <div className="plp__relatedinfo">
                {relatedState &&
                    relatedState?.results.map((item, index) => (
                        <React.Fragment key={`${item?.Title}${index}`}>
                            <SearchResultItemCard
                                // videoSrc={item.videoSrc}
                                label={item?.raw?.content_type}
                                title={item.Title}
                                content={item.excerpt}
                                mediaType={getMediaType(item?.raw?.thumbnail_image, item?.raw?.content_type)}
                                mediaSrc={item?.raw?.thumbnail_image}
                                clickUri={item?.clickUri}
                                item={item}
                            />
                        </React.Fragment>
                    ))}
            </div>
        </>
    );
}
